<template lang="pug">
.contact-page
  img.cover(src="https://img.loklok.video/fe/0e3ecf40-8312-4d09-a155-15f7904a8ab4/contact-cover.png" alt="loklok app screenshot")
  h1(v-t='"navigator.contact"')
  article
    p(v-if="IMUrl.bcEmail || IMUrl.feedbackEmail") E-mail:
    p(v-if="IMUrl.bcEmail")
     a(:href="IMUrl.bcEmail") {{ IMUrl.bcEmail }} ({{$t('contact.business')}})
    p(v-if="IMUrl.feedbackEmail")
     a(:href="IMUrl.feedbackEmail") {{ IMUrl.feedbackEmail }} ({{$t('contact.question')}})
    //- p WhatsApp: 
    //-   a() +62 81213706242
    p(v-for="im of otherIMUrl" v-if="im.value") {{ im.label }}: 
      a(:href="im.value" target="_blank") {{ im.value }}
    p(v-if="IMUrl. privacy") privacy agreement: 
     a(:href="IMUrl.privacy") {{ IMUrl.privacy }} 

</template>
<script>
import getStructuredJson from '@/util/structuredData'
import { mapGetters } from 'vuex'

export default {
  props: ['error'],
  layout: 'default', // 你可以为错误页面指定自定义的布局
  async asyncData({ app, redirect, $ua }) {
    // const data = await app.$api.querySnsByArea({})
    // return {
    //   IMUrl: data
    // }
    try {
      const seoRes = await app.$api.queryKeyword()
      return {
        seoKeyword: seoRes.keyword
      }
    } catch (e) {
      return { seoKeyword: '' }
    }
  },
  head() {
    return {
      title: this.$t('seo.contact.title'),
      meta: [
        { name: 'keywords', content: `${this.seoKeyword ? this.seoKeyword + ',' : ''}${this.$t('seo.contact.keywords')}` },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.contact.description') + '- loklok'
        },
        { rel: 'canonical', href: 'https://loklok.top' + this.localePath('/download_nd') }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: [
            getStructuredJson.bread([
              { name: this.$t('seo.index.title'), path: 'https://loklok.top' + this.localePath('/') },
              { name: this.$t('seo.contact.title'), path: 'https://loklok.top' + this.localePath('/contact') }
            ])
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['IMUrl', 'otherIMUrl'])
  },
  methods: {},
  mounted() {
    console.log('链接配置==============', { IMUrl: this.IMUrl, otherIMUrl: this.otherIMUrl })
  }
}
</script>
<style scoped lang="sass">
.contact-page
  @include border-box
  align-items: left
  max-width: 1240px
  margin: 0 auto
  user-select: none
  padding-top: 20px
  padding-left: 20px
  padding-right: 20px
  display: flex
  flex-direction: column
  align-items: self-start
  .cover
    flex-shrink: 1
    width: 100%
    margin-bottom: 4px
    object-fit: contain
  h1
    font-style: normal
    font-weight: 700
    font-size: 24px
    line-height: 150%
    color: #F5F5F5
    margin: 20px 0
  article
    font-style: normal
    font-weight: 700
    font-size: 14px
    line-height: 200%
    color: #999999
    word-break: break-all
    p
      margin: 20px 0
    a
      color: $mainColor
      user-select: text
@media screen and (max-width: 960px)
  .contact-page
    padding-left: 40px
    padding-right: 40px
    // .cover
    //   display: none
@media screen and (max-width: 750px)
  .contact-page
    padding-left: 20px
    padding-right: 20px
    justify-content: center
    // .cover
    //   display: none
    // .center-wrap
    //   display: none
</style>
